<template functional>
  <div :class="[data.class, data.staticClass]" class="page-header-chat"><a :href="props.chatUrl" @click.prevent="listeners.chat">Chat</a></div>
</template>
<script>
export default {
  props: ['chatUrl'],
};
</script>
<style></style>
